import { ResultObjectType } from '@cbgms/api'
import { ResultTitle } from './Title'
import { Box, Typography } from '@mui/material'
import TreeSelectIcon from '@mui/icons-material/AltRoute'
import SearchIcon from '@mui/icons-material/Search'
import { useTranslation } from 'react-i18next'
import { StackedIcon } from '@carsys/ui'
import { useCallback } from 'react'
import { VirtualSearchResultType } from './TopSearchResultType'
import { useSearchResultTypeContext } from '../../context/SearchResultTypeContext'
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined'

export interface CallToActionCreateVehicleManuallyProps {
  Type: VirtualSearchResultType.CallToActionCreateVehicleManually
  query: string
  clearQuery: () => void
  primaryAction: () => Promise<void>
  hasGroupHeader: boolean
}

const CallToActionCreateVehicleManually: React.FC<CallToActionCreateVehicleManuallyProps> = ({ query, hasGroupHeader, primaryAction }) => {
  const { isPortal } = useSearchResultTypeContext()
  const { t } = useTranslation()

  const onClick = useCallback(
    (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
      e.stopPropagation()
      primaryAction()
    },
    [primaryAction]
  )

  return (
    <Box key='search-parts-with-query' sx={{ display: 'flex', cursor: 'pointer' }} onClick={onClick}>
      {isPortal ? (
        <ShoppingCartOutlinedIcon fontSize='small' />
      ) : (
        <StackedIcon SecondaryIcon={<SearchIcon />} MainIcon={<TreeSelectIcon />} secondaryIconPosition='bottom-right' />
      )}
      <Box sx={{ ml: 0.5 }}>
        <ResultTitle resultType={ResultObjectType.GenericVehicle} isTitleVisible={!hasGroupHeader} />
        <Typography>
          {isPortal ? t('vehicle.start_new_order_for_unknown_vehicle', { searchTerm: query }) : t('global.create_unknown_vehicle')}
        </Typography>
      </Box>
    </Box>
  )
}

export default CallToActionCreateVehicleManually
